import { render, staticRenderFns } from "./ViewTransactionDetails.vue?vue&type=template&id=601d1801&scoped=true&lang=pug&"
import script from "./ViewTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./ViewTransactionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ViewTransactionDetails.vue?vue&type=style&index=0&id=601d1801&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601d1801",
  null
  
)

export default component.exports